/**
 * Tiny circular spinner. Default size matches a 20px control; pass a number
 * via `size` to override. Uses `border` rather than SVG so colors can be
 * driven through Tailwind's text utility.
 */
export function Spinner({ size = 20, className = '' }: { size?: number; className?: string }) {
  return (
    <span
      className={`inline-block rounded-full border-2 border-current border-t-transparent animate-spin align-middle ${className}`}
      style={{ width: size, height: size, color: 'currentColor' }}
      role="status"
      aria-label="Loading"
    />
  );
}

/** Centered loading state for a full panel/card. */
export function LoadingCenter({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="card p-12 flex flex-col items-center gap-3 text-fg-muted">
      <Spinner size={24} className="text-accent" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
